export default __webpack_public_path__ + "static/media/interview_insights.e2949d56.svg";